import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { TOAST_ERROR, setCookie } from "../../../../../utils";
import { getUserInfo } from "../../../../../actions/loginActions";
import { checkStripSession, getProductAndPlanDetails, successCallback } from "../../../../../actions/product_details_action";
import LoadingScreen from "../../../../CommonComponents/LoadingScreen";
import Swal from "sweetalert2";

let loading = false;
export default function StripeCallback() {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const sessionId = params.sessionId;
    const referenceId = localStorage.getItem("referenceId");
    if(!loading){
      loading = true;
      let planValue = '';
      let currency = '';
      let purchased = [];
      checkStripSession({ referenceId, sessionId, isProrated: false }).then((res) => {
        const { responseCode, responseData } = res.data;
        if (responseCode == 200) {
          if(responseData.isEventDateSelected == false) setCookie('eventPopup', "2", { path: '/' });

          purchased = responseData?.items ?? [];
          planValue = responseData?.planValue ?? "";
          currency = String(responseData?.planCurrency).toUpperCase();

          successCallback(referenceId).then((res) => {
              const { responseData, responseCode } = res.data;
              setTimeout(() => { loading = false; }, 1000);

              if (responseCode == 200 && responseData && Object.keys(responseData).length > 0) {
                const { upgradePlan } = responseData;
                const planDetails = {
                  planValue,
                  tnxId: referenceId,
                  planName: upgradePlan,
                  currency,
                  purchased
                }  
                localStorage.setItem('planDetails',JSON.stringify(planDetails));
                navigate(`/socialwalls/accounts/success`);
                dispatch(getUserInfo(navigate, false, false, true, ()=>{
                  dispatch(getProductAndPlanDetails());
                }));

                setTimeout(() => {
                  Swal.fire({
                    title: "Plan Upgrade",
                    text: "Your " + upgradePlan + " successfully updated.",
                    icon: "success",
                    timer: 2000,
                    showCancelButton: false,
                    showConfirmButton: false,
                  });
                }, 3000);
              }
            }).catch((error) => {
              setTimeout(() => { loading = false; }, 1000);
              if(error && error.response?.data){
                const { data } = error.response;
                if(data && Object.keys(data).length > 0){
                  const { responseMessage } = data;
                  TOAST_ERROR(responseMessage);
                  navigate(`/socialwalls/walls/home`);
                }
              } else TOAST_ERROR(error.message);
            });
        }
      }).catch((error) => {
        setTimeout(() => { loading = false; }, 1000);
        if(error && error?.response?.data){
          const { data } = error.response;
          if(data && Object.keys(data).length > 0){
            const { responseMessage } = data;
            TOAST_ERROR(responseMessage);
            navigate(`/socialwalls/walls/home`);
          }
        }else{
          TOAST_ERROR(error.message);
        }
      });
    }
  }, []);

  return <LoadingScreen />;
}
